
import BaseCmsBlock from "../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin";
import { scrollWatcher } from '~/helpers/scroll-watcher.js';
import { homePageWatcher } from "~/helpers/is-main-page";

export default BaseCmsBlock.extend({

  data: function() {
    return {
      isAnimate: false,
    };
  },

  mounted: function () {
    document.addEventListener('scroll', this.inFieldOfView);
  },

  unMounted: function () {
    document.removeEventListener('scroll', this.inFieldOfView);
  },

  computed: {
    title: function () {
      return this.values?.title || ''
    },
    items: function () {
      return this.values?.items || []
    },

    isVisibleButtonForm: function () {
      return String(this.values?.hidden_button_form || 0) === '0'
    },
    isHome: function () {
      return homePageWatcher(this.$route.fullPath)
    },
    howWorksClasses: function() {
      let _classes = '';
      if (this.cfgs?.theme) {
        _classes = _classes.concat(' ', this.cfgs?.theme);
      }
      if (this.$additionalBlockClasses(this.cfgs)) {
        _classes = _classes.concat(' ', this.$additionalBlockClasses(this.cfgs));
      }
      if (this.isHome) {
        _classes = _classes.concat(' ', 'padding-home');
      }
      return _classes;
    },
  },

  methods: {
    openForm: function () {
      if (this.cfgs?.reach_goal_open_form) {
        this.$yandexMetrika.reachGoal(this.cfgs?.reach_goal_open_form);
        this.$yaglaaction(this.cfgs?.reach_goal_open_form);
      }

      this.$store.commit("back-call/setOpen", {
        open: true,
        settings: {
          type: 'Оставить заявку',
          hideTabs: true,
          miniReachGoal: this.cfgs?.reach_goal_send_form || ''
        }
      });
    },
    inFieldOfView: function () {
      if (!this.isHome) {
        return
      }
      if (scrollWatcher('how-works-v2-block__content-block')) {
        document.removeEventListener('scroll', this.inFieldOfView);
        this.isAnimate = true;
      }
    },
    computedClassForCards: function(index) {
      let customClass = '';
      if (this.isAnimate && this.isHome) {
        customClass = `--animate-how-works-card --animate-how-works-card_${index}`;
      }
      if (!this.isHome) {
        customClass = '--opacity-1';
      }
      return customClass;
    },
    computedClassForDevider: function(index) {
      let customClass = '';
      if (this.isAnimate && this.isHome) {
        customClass = `--animate-divider --animate-divider_${index}`;
      }
      if (!this.isHome) {
        customClass = '--opacity-1';
      }
      return customClass;
    }
  }

});
